document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-prev', 
            prevEl: '.swiper-next'
        }
        ,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    // start slider default
    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });

    var daySlider = new Swiper('.day-slider', {
        slidesPerView: 1,
        loop: true,
        pagination: {
            clickable: true,
            el: ".swiper-pagination",
        }
    });

    // Inicializar slider de noche
    var nightSlider = new Swiper('.night-slider', {
        slidesPerView: 1,
        loop: true,
        pagination: {
            clickable: true,
            el: ".swiper-pagination",
        }
    });


    let single_quad_slider = new Swiper(".single-quad-swiper", {
        loop: true,
        effect: "fade",
        fadeEffect: {
            crossFade: true
        },
        pagination: {
            el: ".swiper-pagination",
            type: "fraction",
        },
        navigation: {
            nextEl: ".sw-gal-next",
            prevEl: ".sw-gal-prev",
        }
    });
    
    let quadGallery = new Swiper('.gallery-one__slider',{
        speed: 700,
        centeredSlides: true,
        loop:true,
        initialSlide: 1,
        navigation: {
            prevEl: '.sw-gal-prev',
            nextEl: '.sw-gal-next'
        },
        breakpoints: {
            320: {
                spaceBetween: 15,
                slidesPerView: 1.2
            },
            600:{
                spaceBetween: 30,
                slidesPerView: 1.5   
            }
        }
    })
    

    let waveGallery = new Swiper('.wave-list__slider',{
        loop: true,
        effect: "fade",
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: ".sw-gal-next",
            prevEl: ".sw-gal-prev",
        }
        
    })

    let singleQuad = new Swiper('.single-quad__slider',{
        loop: true,
        effect: "fade",
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: ".sw-gal-next",
            prevEl: ".sw-gal-prev",
        }
        
    })

    let ListSlider = new Swiper('.list__slider',{
        loop: true,
        effect: "fade",
        slidesPerView: 1,
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: ".sw-gal-next",
            prevEl: ".sw-gal-prev",
        }
        
    })

//   Home day night slider mobile 

    var daySliderHome = new Swiper('.day-slider_home', {
        slidesPerView: 1,
        loop: true,
        navigation: {
            nextEl: ".sw-gal-next",
            prevEl: ".sw-gal-prev",
        }
    });

    var nightSliderHome = new Swiper('.night-slider_home', {
        slidesPerView: 1,
        loop: true,
        navigation: {
            nextEl: ".sw-gal-next",
            prevEl: ".sw-gal-prev",
        }
    });
    

});